import {
  IDashboardCarsAvgTicketTiresTrendsResponse,
  IDashboardSalesTrendsResponse
} from '../../interfaces/dashboard-average-trends.inteface'
import { IDashboardBenchmarkSalesResponse } from '../../interfaces/dashboard-benchmark-sales.interface'
import { IDashboardLaborResponse } from '../../interfaces/dashboard-labor.inteface'
import { IDashboardGrossProfitResponse } from '../../interfaces/dashboard-gross-profit.inteface'
import { IDashboardGoalsResponse } from '../../interfaces/dashboard-goals.inteface'
import { IDashboardRankingResponse } from '../../interfaces/dashboard-ranking.inteface'

export interface DashboardStateModel {
  salesTrend: IDashboardSalesTrendsResponse
  carsAvgTicketTiresTrend: IDashboardCarsAvgTicketTiresTrendsResponse
  benchmarkSales: IDashboardBenchmarkSalesResponse
  labors: IDashboardLaborResponse
  grossProfit: IDashboardGrossProfitResponse
  goals: IDashboardGoalsResponse
  ranking: IDashboardRankingResponse
}
